module.exports = __webpack_public_path__ + "img/1-3-IMG_3001.05c1bb39.png";